export default __webpack_public_path__ + "static/media/CSS3.5da907d7.svg";